import type { IconData } from '@stacksjs/iconify-core'

export const zoomOut: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M96.344 175.313h192v32h-192z\"/><path fill=\"currentColor\" d=\"m479.6 399.716l-81.084-81.084l-62.368-25.767A175 175 0 0 0 368 192c0-97.047-78.953-176-176-176S16 94.953 16 192s78.953 176 176 176a175.03 175.03 0 0 0 101.619-32.377l25.7 62.2l81.081 81.088a56 56 0 1 0 79.2-79.195M48 192c0-79.4 64.6-144 144-144s144 64.6 144 144s-64.6 144-144 144S48 271.4 48 192m408.971 264.284a24.03 24.03 0 0 1-33.942 0l-76.572-76.572l-23.894-57.835l57.837 23.894l76.573 76.572a24.03 24.03 0 0 1-.002 33.941\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default zoomOut
